import React, { Component } from "react";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";
import queryString from "query-string";
import Loadable from "react-loadable";
import Loader from "../../_components/Loader/Loader";
import allApis from "./allApis";
import { expertBioApiConstants } from "./constants";
import { changeModuleId, changeModule } from "../../actions/userAccessCheck";
import { getExperts } from "../../actions/expertsAction/expertsAction";
import { getExpertsWithFilter } from "../../actions/expertsAction/filterAction";
import { getRelatedTerms } from "../../actions/relatedTermsAction/relatedTermsAction";
import { getsummaryText } from "../../actions/expertsAction/summaryAction";
import { getTweets } from "../../actions/tweetsAction/tweetsAction";
import Error from "./Error";
import _livSize from "../../constants/_livSize";

//moving from redux to _services
import {
  getHistogram,
  getCollabs,
  getCollabsMultiple,
  getCredentials,
  getArticles,
  getMoreArticles,
  getArticlesMultiple,
  getArticlesMultipleMore,
  getClinicalTrials,
  getGrants,
  getMoreGrants,
  getMsArticles,
  getMoreMsArticles,
  getPayments,
  getMorePayments,
  getExternalLinks,
  getPatents,
} from "../../_services/application/expertBio";

const ExpertBio = Loadable({
  loader: () => import("../../_components/ExpertBio/ExpertBio"),
  loading: () => (
    <div>
      {" "}
      <Loader />{" "}
    </div>
  ),
});

const fullProfileConstants = ["totalArticles", "totalTrials"];

class ExpertBioContainer extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      showFullProfile: "no",
      expertId: "",
      keyword: null,
      isFetching: true,
      expertin: "",
      searchKey: "",
      moduleId: "GENERAL",
      expertInfo: {},
      ...expertBioApiConstants,
    };
  }

  toggleProfile = (type) => {
    this.setState(
      {
        showFullProfile: type,
      },
      this.callAllApis
    );
  };

  callAllApis = async () => {
    let {
      expertId,
      isFullProfile,
      isMultiKeyword,
      expertin,
      showFullProfile,
      articles,
      moduleId,
      keyword,
    } = this.state;

    let { token, keywords, entities, filters, customFilters } = this.props;
    keywords = [];
    keywords = keywords || [];

    // CALL THE API FOR SINGLE KEYWORDS
    this.setState({ isFetching: true });
    const results = allApis({
      token,
      expertId,
      keyword: keyword,
      expertin,
      moduleId,
      showFullProfile,
      state: this.state,
      entities: entities,
      filters,
      customFilters: customFilters,
    });

    results
      .then((data) => {
        let keys = Object.keys(data);
        for (let i of keys) {
          if (data[i]) {
            if (i === "credentials") this.setState({ isFetching: false });
            this.setState({ [i]: { ...this.state[i], ...data[i] } });
          }
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isFetching: false });
      });

    //AUTO SCROLL TO TOP WHEN PAGE LOADS
    window.scrollTo(0, 0);
  };

  intializeRequest = async () => {
    this._isMounted = true;
    let { showFullProfile } = this.state;
    let { entities, filters, customFilters } = this.props;

    // expertId from the url
    let expertId = this?.props?.match?.params?.id || this?.props?.expertId;
    let expertInfo = this.props?.location?.state?.expertInfo || this.props?.expertInfo || {};
    

    let keyword = queryString.parse(window.location.search)?.searchKey;
    let queryParams = queryString.parse(this.props.location?.search);

    // only show topic-specific if coming from table and has topic-specific keyword
    // otherwise show full-profile
    if (!this.props?.isFindIndProfileView && this.props?.keyword) {
      keyword = this.props?.keyword;
    }

    let { isFullProfile, isMultiKeyword, expertin, moduleId = "GENERAL", citationRank } = queryParams;

     if(!expertInfo.citationRank){
      expertInfo['citationRank'] = citationRank;
    }

    this.setState({
      expertId,
      isFullProfile,
      isMultiKeyword,
      keyword,
      expertin,
      moduleId,
      entities,
      expertInfo,
    });

    let { token, keywords } = this.props;
    let { articles } = this.state;
    keywords = keywords || [];

    //IF FULL PROFILE QUERY DON'T SEND KEYWORD
    // if (isFullProfile == "true") {
    //   keyword = undefined;
    //   keywords = [];
    // } else if (this.state.keyword) {
    //   keyword = this.state.keyword;
    // }

    //CHECK MULTIPLE KEYWORDS
    if (keywords.length >= 2 && isMultiKeyword == "true") {
      //CALL THE API FOR MULTIPLE KEYWORDS
      try {
        this.setState({ isFetching: true });
        let histogram = await getHistogram(token, {
          expertId,
          keyword,
          expertin,
          entities,
        });
        let collabs = await getCollabsMultiple(token, { expertId, keywords });
        let multipleArticles = await getArticlesMultiple(token, {
          expertId,
          keywords,
          size: articles.size,
          from: articles.from,
          entities,
        });
        let trials = await getClinicalTrials(token, {
          expertId,
          keyword,
          expertin,
          isMulti: true,
          from: this.state.trials.from,
          size: this.state.trials.size,
          activePage: this.state.trials.activePage,
          entities,
        });
        let grants = getGrants(token, {
          expertId,
          keyword,
          size: 10,
          from: 0,
          entities,
        });

        this.setState({
          histogram,
          collabs,
          trials: { ...this.state.trials, ...trials },
          articles: { ...this.state.articles, ...multipleArticles },
          grants: { ...this.state.grants, ...grants },
          isFetching: false,
        });
      } catch (err) {
        console.log(err);
      }
    } else {
      let apiKeys = Object.keys(expertBioApiConstants);
      for (let i of apiKeys) {
        this.setState({ [expertBioApiConstants[i].isFetching]: true });
      }

      // CALL THE API FOR SINGLE KEYWORDS
      this.setState({ isFetching: true });
      const results = allApis({
        token,
        expertId,
        keyword,
        expertin,
        moduleId,
        showFullProfile,
        state: this.state,
        entities: entities,
        filters: filters,
        customFilters,
      });

      let newState = {};
      results
        .then((data) => {
          let keys = Object.keys(data);
          for (let i of keys) {
            if (data[i]) {
              if (i === "credentials") this.setState({ isFetching: false });
              newState = {
                ...newState,
                [i]: { ...this.state[i], ...data[i], isFetching: false },
              };
            } else {
              newState = {
                ...newState,
                [i]: expertBioApiConstants[i]
              }
            }
          }
          if (this._isMounted) {
            this.setState({ ...newState, isFetching: false });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isFetching: false });
        });
    }
    //AUTO SCROLL TO TOP WHEN PAGE LOADS
    window.scrollTo(0, 0);
  };

  componentDidMount() {
    this.intializeRequest();
    let scrollProfileTo = this.props?.scrollProfileTo;
    if (scrollProfileTo && fullProfileConstants.includes(scrollProfileTo)) {
      this.setState({ showFullProfile: "yes" });
    } else {
      this.setState({ showFullProfile: "no" });
    }
  }

  componentDidUpdate() {
    let { expertId: propExpertId, isFindIndProfileView } = this.props;
    let { expertId: stateExpertId } = this.state;

    if (propExpertId !== stateExpertId && isFindIndProfileView) {
      this.intializeRequest();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getExperts = (keyword) => {
    const { token } = this.props;

    this.props.history.push("/result/experts");
    this.props.getExperts(keyword, token);
    this.props.getsummaryText(keyword, token);
    this.props.getRelatedTerms(keyword, token);
    this.props.getTweets(keyword, token);
  };

  getMoreExpertGrants = async () => {
    let { token, entities } = this.props;
    let { grants } = this.state;

    const { from, size } = grants;
    const { expertId, isFullProfile, isMultiKeyword } = this.state;

    //IF FULL PROFILE QUERY DON'T SEND KEYWORD
    if (isFullProfile == "true") {
      keywords = [];
    }

    try {
      let moreGrants = await getMoreGrants(token, {
        expertId,
        size,
        from,
        entities,
      });
      this.setState({ grants: { ...this.state.grants, ...moreGrants } });
    } catch (err) {
      console.log(err);
    }
  };

  getMoreExpertArticles = async (from, selectedPage) => {
    let { token, keywords } = this.props;
    keywords = keywords || [];

    const {
      expertId,
      isFullProfile,
      isMultiKeyword,
      expertin,
      showFullProfile,
      articles,
    } = this.state;

    let { size, sort } = articles;

    //IF FULL PROFILE QUERY DON'T SEND KEYWORD
    if (isFullProfile == "true") {
      keywords = [];
    }

    //CHECK MULTIPLE KEYWORDS
    if (keywords.length >= 2 && isMultiKeyword == "true") {
      //CALL THE API FOR MULTIPLE KEYWORDS
      try {
        this.setState({ isFetching: true });
        let articlesMultipleMore = await getArticlesMultipleMore(token, {
          expertId,
          keywords,
          size,
          from,
          expertin,
          selectedPage,
          sort,
        });
        this.setState({
          articles: { ...this.state.articles, ...articlesMultipleMore },
          isFetching: false,
        });
      } catch (err) {
        console.log(err);
        this.setState({ isFetching: false });
      }
    } else {
      try {
        this.setState({ isFetching: true });
        let moreArticles = await getMoreArticles(token, {
          expertId,
          size,
          from,
          expertin,
          selectedPage,
          sort,
          showFullProfile,
        });
        this.setState({
          articles: { ...this.state.articles, ...moreArticles },
          isFetching: false,
        });
      } catch (err) {
        console.log(err);
        this.setState({ isFetching: false });
      }
    }
  };

  getMoreExpertMsArticles = async (from, selectedPage) => {
    this.setState({ isFetching: true });
    let { token, expertMsaArticles } = this.props;

    const { size } = expertMsaArticles;
    const { expertId, keyword } = this.state;

    let moreMsArticles = await getMoreMsArticles(token, {
      expertId,
      keyword,
      size,
      from,
      activePage: selectedPage,
    });
    this.setState({
      msArticles: {
        ...this.state.msArticles,
        ...moreMsArticles,
        size,
        from,
        activePage: selectedPage,
      },
      isFetching: false,
    });
  };

  getMoreOpenPayments = async (from, selectedPage) => {
    let { token } = this.props;
    let { payments, keyword } = this.state;

    const { size } = payments;
    const { expertId } = this.state;

    let morePayments = await getMorePayments(token, {
      expertId,
      keyword,
      size,
      from,
      activePage: selectedPage,
      showFullProfile: isFullProfile === "true" ? "yes" : "no",
    });
    this.setState({ payments: { ...this.state.payments, ...morePayments } });
  };

  handlePagination = async (type, selectedPage) => {
    let {
      patents = {},
      articles = {},
      trials = {},
      grants = {},
      expertId,
      expertin,
      sort,
      showFullProfile,
      moduleId,
      payments,
      msArticles,
      keyword,
    } = this.state;
    if(_livSize.isMobile()){
      window.scrollTo(0,0);
    }

    let { token, entities } = this.props;
    
    if (type === 'patents'){
      this.setState({ patents: { ...this.state.patents, isFetching: true } });
      let { size, activePage } = patents;
      if (activePage !== selectedPage) {
        let from = selectedPage * size - 10;
        if (selectedPage === 1) {
          from = 1;
        }
        try {
          let moreArticles = await getPatents(token, {
            expertId,
            keyword,
            size,
            from,
            expertin,
            selectedPage,
            sort,
            showFullProfile,
            moduleId,
            entities,
          });

          if (moreArticles) {
            return this.setState({
              patents: {
                ...moreArticles,
                from,
                size,
                activePage: selectedPage,
                isFetching: false,
              },
            });
          }
          this.setState({
            patents: { ...this.state.patents, isFetching: false },
          });
        } catch (err) {
          console.log(err);
          this.setState({
            articles: { ...this.state.articles, isFetching: false },
          });
        }
      }

    }
    else if (type === "articles") {
      this.setState({ articles: { ...this.state.articles, isFetching: true } });
      let { size, activePage } = articles;
      if (activePage !== selectedPage) {
        let from = selectedPage * size - 10;
        if (selectedPage === 1) {
          from = 1;
        }
        try {
          let moreArticles = await getMoreArticles(token, {
            expertId,
            keyword,
            size,
            from,
            expertin,
            selectedPage,
            sort,
            showFullProfile,
            moduleId,
            entities,
          });

          if (moreArticles) {
            return this.setState({
              articles: {
                ...moreArticles,
                from,
                size,
                activePage: selectedPage,
                isFetching: false,
              },
            });
          }
          this.setState({
            articles: { ...this.state.articles, isFetching: false },
          });
        } catch (err) {
          console.log(err);
          this.setState({
            articles: { ...this.state.articles, isFetching: false },
          });
        }
      }
    } else if (type === "trials") {
      this.setState({ trials: { ...this.state.trials, isFetching: true } });
      let { size, activePage } = trials;
      if (activePage !== selectedPage) {
        let from = selectedPage * size - 10;
        if (selectedPage === 1) {
          from = 0;
        }
        try {
          let trials = await getClinicalTrials(token, {
            expertId,
            keyword,
            expertin,
            isMulti: true,
            from,
            size,
            moduleId,
            entities,
          });

          if (trials) {
            return this.setState({
              trials: {
                ...trials,
                from,
                size,
                activePage: selectedPage,
                isFetching: false,
              },
            });
          }
          this.setState({
            trials: { ...this.state.trials, isFetching: false },
          });
        } catch (err) {
          console.log(err);
          this.setState({
            trials: { ...this.state.trials, isFetching: false },
          });
        }
      }
    } else if (type === "grants") {
      this.setState({ grants: { ...this.state.grants, isFetching: true } });
      let { size, activePage } = grants;
      if (activePage !== selectedPage) {
        let from = selectedPage * size - 10;
        if (selectedPage === 1) {
          from = 1;
        }
        try {
          let grants = await getGrants(token, {
            expertId,
            keyword,
            size,
            from,
            moduleId,
            entities,
          });

          if (grants) {
            return this.setState({
              grants: {
                ...grants,
                from,
                size,
                activePage: selectedPage,
                isFetching: false,
              },
            });
          }
          this.setState({
            grants: { ...this.state.grants, isFetching: false },
          });
        } catch (err) {
          console.log(err);
          this.setState({
            grants: { ...this.state.grants, isFetching: false },
          });
        }
      }
    } else if (type === "payments") {
      this.setState({ payments: { ...this.state.payments, isFetching: true } });
      let { size, activePage } = payments;
      if (activePage !== selectedPage) {
        let from = selectedPage * size - 10;
        if (selectedPage === 1) {
          from = 1;
        }
        try {
          let payments = await getPayments(token, {
            expertId,
            keyword,
            size,
            from,
            moduleId,
            entities,
            showFullProfile,
          });

          if (payments) {
            return this.setState({
              payments: {
                ...payments,
                from,
                size,
                activePage: selectedPage,
                isFetching: false,
              },
            });
          }
          this.setState({
            payments: { ...this.state.payments, isFetching: false },
          });
        } catch (err) {
          console.log(err);
          this.setState({
            payments: { ...this.state.payments, isFetching: false },
          });
        }
      }
    } else if (type === "msa-articles") {
      this.setState({
        msArticles: { ...this.state.msArticles, isFetching: true },
      });
      let { size, activePage } = msArticles;
      if (activePage !== selectedPage) {
        let from = selectedPage * size - 10;
        if (selectedPage === 1) {
          from = 1;
        }
        try {
          let msArticles = await getMsArticles(token, {
            expertId,
            keyword,
            size,
            from,
            moduleId,
            entities,
          });

          if (msArticles) {
            return this.setState({
              msArticles: {
                ...msArticles.msArticles,
                from,
                size,
                activePage: selectedPage,
                isFetching: false,
              },
            });
          }
          this.setState({
            msArticles: { ...this.state.msArticles, isFetching: false },
          });
        } catch (err) {
          console.log(err);
          this.setState({
            msArticles: { ...this.state.msArticles, isFetching: false },
          });
        }
      }
    }
  };

  handleSortChange = async (type, sort) => {
    const { token, keywords } = this.props;
    const {
      expertId,
      isMultiKeyword,
      expertin,
      showFullProfile,
      articles,
      moduleId,
      keyword,
    } = this.state;

    if (type === "articles") {
      this.setState({ articles: { ...this.state.articles, isFetching: true } });
      let { size, from, activePage } = articles || {};
      if (keywords.length >= 2 && isMultiKeyword == "true") {
        try {
          let articlesMultipleMore = await getArticlesMultipleMore(token, {
            expertId,
            keyword,
            size,
            from,
            expertin,
            activePage,
            sort,
            moduleId,
          });

          if (articlesMultipleMore) {
            this.setState({
              articles: {
                ...this.state.articles,
                ...articlesMultipleMore,
                sort,
                isFetching: false,
              },
            });
          }
        } catch (err) {
          console.log(err);
          this.setState({
            articles: { ...this.state.articles, isFetching: false },
          });
        }
        return;
      }
      try {
        let moreArticles = await getMoreArticles(token, {
          expertId,
          keyword,
          size,
          from,
          expertin,
          activePage,
          sort,
          showFullProfile,
          moduleId,
        });

        if (moreArticles) {
          return this.setState({
            articles: {
              ...this.state.articles,
              ...moreArticles,
              sort,
              isFetching: false,
            },
          });
        }
      } catch (err) {
        console.log(err);
      }
    }
    this.setState({ articles: { ...this.state.articles, isFetching: false } });
  };

  render() {
    const {
      history,
      keywords,
      token,
      expertMsaArticles,
      expertPayments,
      modulesList,
      isFindIndProfileView,
      isProfilePreview,
      handleSeeOtherOptions,
      showProfileSlide,
      scrollProfileTo,
      onSubmit,
      filters,
    } = this.props;

    const {
      expertId,
      isFullProfile,
      isMultiKeyword,
      expertin,
      externalLinks,
      showFullProfile,
      isFetching,
      keyword,
      histogram,
      collabs,
      credentials,
      articles,
      msArticles,
      trials,
      grants,
      moduleId,
      payments,
      expertInfo = {},
      patents,
    } = this.state;

  
    if (isFetching) {
      return <Loader />;
    }

    // if (Object.keys(credentials?.credentials)?.length === 0 && !isFetching) {
    //   return <Error />;
    // }


    if (!isProfilePreview && !isFindIndProfileView) {
      document.body.style.overflowY = "auto";
    }

    return (
      <div>
          <ExpertBio
            showProfileSlide={showProfileSlide}
            scrollProfileTo={scrollProfileTo}
            expertMsaArticles={msArticles}
            expertPayments={payments}
            histogram={histogram}
            articles={articles}
            credentials={credentials}
            history={history}
            externalLinks={externalLinks}
            getExperts={this.getExperts}
            keyword={keyword}
            trials={trials}
            collabs={collabs}
            expertId={expertId}
            getMoreExpertArticles={this.getMoreExpertArticles}
            getMoreExpertMsArticles={this.getMoreExpertMsArticles}
            getMoreOpenPayments={this.getMoreOpenPayments}
            getExpertArticlesMultipleMore={this.props.getExpertArticlesMultipleMore}
            isFullProfile={isFullProfile}
            isMultiKeyword={isMultiKeyword}
            keywords={keywords || []}
            grants={grants}
            getMoreExpertGrants={this.getMoreExpertGrants}
            expertin={expertin}
            token={token}
            handlePagination={this.handlePagination}
            handleSortChange={this.handleSortChange}
            showFullProfile={showFullProfile}
            toggleProfile={this.toggleProfile}
            moduleId={moduleId}
            modulesList={modulesList}
            isFindIndProfileView={isFindIndProfileView}
            isProfilePreview={isProfilePreview}
            handleSeeOtherOptions={handleSeeOtherOptions}
            onSubmit={onSubmit}
            expertInfo={expertInfo}
            patents={patents}
          />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.Global.token,
  keyword: state.Experts.keyword,
  keywords: state.Experts.keywords.map((l) => l.keyword),
  entities: state.Experts.entities,
  modulesList: state.Global.modulesList,
  filters: state.Experts.filters,
  customFilters: state.Experts.customFilters,
});

export default connect(mapStateToProps, {
  getExperts,
  getExpertsWithFilter,
  getTweets,
  getRelatedTerms,
  getsummaryText,
  changeModuleId,
  changeModule,
})(ExpertBioContainer);
